import { Component } from '@angular/core';
import { Router, NavigationEnd } from "@angular/router"

import { HerramientasService } from '@app/_services/herramientas.service';

import { TranslateService } from '@ngx-translate/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MenuService, UsuariosService } from '../_services';

@Component({
  selector: 'app-tiposHerramientas',
  templateUrl: 'tiposHerramientas.component.html'
})

export class TiposHerramientasComponent {

  public seleccionados: number[] = [];
  private translate: TranslateService;
  public tiposHerramientas: [];
  modalReference: NgbModalRef;
  modalReferenceloading: NgbModalRef;
  closeResult = '';
  navigationSubscription;
  user = this.userService.userValue;

  constructor(private herramientasService: HerramientasService,
    translate: TranslateService,
    private menuService: MenuService, public router: Router,
    private translateService: TranslateService,
    private userService: UsuariosService,
    private modalService: NgbModal) {

    this.translate = translate;
    this.menuService.titulo = this.translate.instant('tiposHerramientas').toUpperCase();

    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        if (this.router.url == '/tiposHerramientas') {
          this.menuService.titulo = this.translateService.instant('tiposHerramientas');
          this.herramientasService.get_tiposHerramientas().subscribe(
            (result) => {
              this.tiposHerramientas = result.data;
            }
          );
        } else {

        }
      }
    });
  }

  ngOnInit() {
    this.herramientasService.get_tiposHerramientas().subscribe(
      (result) => {
        var an: any = result.data;
        this.tiposHerramientas = an;
      }
    );
  }

  onClickNuevo() {
    this.router.navigate(['tiposHerramientas/crear/']);
  }

  onClickEditar() {
    if (this.seleccionados[0] > 0) {
      this.router.navigate(['tiposHerramientas/editar/', this.seleccionados[0]]);
    }
  }

  cellClick(e) {
    if (e.columnIndex > 0) {
      this.router.navigate(['tiposHerramientas/editar/', this.seleccionados[0]]);
    }
  }

  onClickEliminar(content) {
    if (this.seleccionados.length > 0) {
      this.modalReference = this.modalService.open(content, { backdrop: 'static', size: 'lg', keyboard: false, centered: true });
    }
  }

  private eliminarRegistro(contentloading, contentNotErased) {

    this.herramientasService.delete({ ids: this.seleccionados }).subscribe(
      (data) => {
        if (data.error == false) {
          this.herramientasService.get_tiposHerramientas().subscribe(
            (result) => {
              var an: any = result.data;
              this.tiposHerramientas = an;
            }
          );
        }
        if (data.undeletedElements != "") {

          this.modalService.open(contentNotErased, { backdrop: 'static', size: 'lg', keyboard: false, centered: true });
        }
        this.modalReferenceloading.close();
      }
    );
    this.modalReference.close();
    this.modalReferenceloading = this.modalService.open(contentloading, { backdrop: 'static', size: 'sm', keyboard: false, centered: true });
    this.seleccionados = [];
  }
}
